import React from 'react';
interface TemplateFrameProps {
  componentId: string;
  dimensions: string;
  caption?: string;
  children: React.ReactNode;
  width?: string;
}
/**
 * TemplateFrame
 * Wraps a template artwork in a white "chrome" card so cream-bg templates
 * separate clearly from the cream canvas. Label sits above the chrome,
 * dimensions + caption sit below.
 */
export function TemplateFrame({
  componentId,
  dimensions,
  caption,
  children,
  width = '240px'
}: TemplateFrameProps) {
  return <div className="flex flex-col" style={{
    width
  }} data-id="element-1691">
      {/* Label above */}
      <div className="font-mono text-[10px] uppercase tracking-wider text-film-gray mb-2 truncate" data-id="element-1692">
        {componentId}
      </div>

      {/* White chrome card lifts cream frames off the cream canvas */}
      <div className="bg-white border border-film-border shadow-card p-2.5" data-id="element-1693">
        <div className="relative overflow-hidden bg-white" data-id="element-1694">{children}</div>
      </div>

      {/* Dimensions + caption below */}
      <div className="font-mono text-[10px] text-film-gray mt-2" data-id="element-1695">
        {dimensions}
      </div>
      {caption && <p className="text-xs text-film-gray mt-1 leading-snug" data-id="element-1696">{caption}</p>}
    </div>;
}